import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/live'
  },
  {
    path: '/live',
    name: 'live',
    component: () => import('../views/live/index.vue'),
    meta: {
      title: '直播'
    }
  },
  {
    path: '*',
    name: 'notfount',
    component: () => import('../views/notfount/index.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 切换路由滚动到顶部
    if (savedPosition) {
      return savedPosition
    } else {
      if (from.meta.keepAlive) {
        from.meta.savedPosition = document.body.scrollTop
      }
      return { x: 0, y: to.meta.savedPosition || 0 }
    }
  }
})

routes.forEach((route) => {
  route.path = route.path || '/' + (route.name || '')
})

router.beforeEach(async (to, from, next) => {
  const title = to.meta && to.meta.title
  if (title) {
    document.title = title
  }
  if (store.getters.token) {
    if (to.path === '/login') {
      next('/')
      return
    }

    // 判断用户资料是否获取
    // 若不存在用户信息，则需要获取用户信息
    await store.dispatch('user/getUserInfo')
    next()
    return
  }
  // 没有token的情况下
  /** // 可以进入白名单
  if (whiteList.indexOf(to.path) > -1) {
    next()
  } else {
    next('/login')
  } */
  next()
})

// 解决重复跳转到同一个路由报错问题，VueRouter是指路由对象
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

export default router
